export enum RequestStatus {
  Loading,
  Success,
  Failure,
  Timeout,
  PermissionError,
  ExpirationError,
}
